import { WidgetActions } from '../types';
import { InferenceTaskType } from './Type';

export function addInferenceStatus(payload: InferenceTaskType): WidgetActions {
  return { type: 'ADD_INFERENCE_STATUS', payload };
}
